<template>
  <div
    class="vat-switcher"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <tg-form-switch
      id="vat_switch"
      v-model="enabled"
      :label="$t('text.price.with_vat')"
      :description="true"
      @input="update"
      @mouseover="hover = true"
    />
    <transition name="fade">
      <div
        v-if="enabled && hover"
        class="vat-switcher__description"
      >
        <div class="vat-switcher__text">
          {{ $t('text.price.excl_question') }}
        </div>
        <a
          href="#"
          class="vat-switcher__action"
          @click.prevent="enabled = false"
        >
          {{ $t('text.price.excl_answer') }}
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import TgFormSwitch from '../common/form/fields/TgFormSwitch';
import { VAT_MODE } from '~/constants/vatMode';
import { SET_VAT_MODE } from '~/store/settings';
import CookieService from '~/services/CookieService';

export default {
  name: 'TgVatSwitcher',

  components: {
    TgFormSwitch,
  },

  props: {
    defaultVatDisplayMode: {
      type: String,
      default: VAT_MODE.EXCLUSIVE,
    },
  },

  data: () => {
    return {
      enabled: false,
      hover: false,
    };
  },

  computed: {
    ...mapState({
      vatMode: (state) => state.settings.vatMode,
    }),
    ...mapGetters({
      showVatIncl: 'settings/showVatIncl',
    }),
  },

  created () {
    if (this.$isClient()) {
      const cookieVatMode = CookieService.get('vat');
      if (cookieVatMode !== null) {
        this.updateVatMode(cookieVatMode);
      }
    }

    this.enabled = this.showVatIncl;
    if (this.vatMode === null) {
      this.updateVatMode(this.defaultVatDisplayMode);
      this.enabled = this.defaultVatDisplayMode === VAT_MODE.INCLUSIVE;
    }
  },

  methods: {
    ...mapMutations({
      updateVatMode: `settings/${SET_VAT_MODE}`,
    }),
    update (enabled) {
      const vatMode = enabled ? VAT_MODE.INCLUSIVE : VAT_MODE.EXCLUSIVE;
      CookieService.set('vat', vatMode);
      this.updateVatMode(vatMode);
    },
  },
};
</script>

<style scoped>
.vat-switcher {
  position: relative;
  display: inline-block;
}

.vat-switcher__description {
  z-index: 20;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  position: absolute;
  top: 2rem;
  right: 0;
  left: 0;
  padding: .667rem .75rem;
  background: #fff;
  border: 1px solid #ddd;
  font-size: 13px;
  box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .15);
}

.vat-switcher__action {
  color: var(--text-color);
  text-decoration: underline;
}

.fade-enter-active {
  transition: opacity .15s ease-in-out;
}

.fade-leave-active {
  transition: opacity .5s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
